// NOTE: Same array in app/javascript/controllers/donations_controller.js
const requiredFieldTypes = [
  'email',
  'full_name',
  'first_name',
  'last_name',
  'zip_code',
];

export const buildBillingDetails = (dataFieldsProps) => {
  const { responses, fields } = dataFieldsProps;

  const getResponseValue = (id) =>
    responses.find((r) => r.attributes.dataFieldId === id).attributes.value;
  const filteredFields = fields.filter((f) =>
    requiredFieldTypes.includes(f.attributes.type),
  );

  const billingDetails = filteredFields.reduce((acc, field) => {
    const value = getResponseValue(field.attributes.id);
    switch (field.attributes.type) {
      case 'email':
        acc.email = value;
        break;
      case 'full_name':
        acc.name = value;
        break;
      case 'first_name':
        acc.name = acc.name ? `${value} ${acc.name}` : value;
        break;
      case 'last_name':
        acc.name = acc.name ? `${acc.name} ${value}` : value;
        break;
      case 'zip_code':
        acc.address = { postal_code: value };
        break;
    }
    return acc;
  }, {});

  return billingDetails;
};
